module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"changeLanguage":"Change to English","comingSoon":"Kommer Snart","profile":"Profil"}}')
  delete Component.options._Ctor
}
